'use client';

import { Skeleton } from '@/components/ui/skeleton';
import { TableCell, TableRow } from '@/components/ui/table';

interface SubscriptionsTableSkeletonProps {
  rows?: number;
}

export function SubscriptionsTableSkeleton({ rows = 5 }: SubscriptionsTableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <TableRow key={index}>
          {/* Checkbox */}
          <TableCell>
            <Skeleton className="h-4 w-4" />
          </TableCell>
          {/* Subscription ID */}
          <TableCell>
            <Skeleton className="h-5 w-32" />
          </TableCell>
          {/* Customer (name + email) */}
          <TableCell>
            <div className="space-y-1">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-3 w-40" />
            </div>
          </TableCell>
          {/* Store */}
          <TableCell>
            <Skeleton className="h-4 w-28" />
          </TableCell>
          {/* Processor (icon + name) */}
          <TableCell>
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-4 w-24" />
            </div>
          </TableCell>
          {/* Card Vault (icon + badge) */}
          <TableCell>
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-5 w-24" />
            </div>
          </TableCell>
          {/* Status badge */}
          <TableCell>
            <Skeleton className="h-5 w-16" />
          </TableCell>
          {/* Plan (icon + badge) */}
          <TableCell>
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-5 w-20" />
            </div>
          </TableCell>
          {/* Amount (money + currency) */}
          <TableCell>
            <div className="space-y-1">
              <Skeleton className="h-4 w-20" />
            </div>
          </TableCell>
          {/* Next Billing Date */}
          <TableCell>
            <Skeleton className="h-4 w-24" />
          </TableCell>
          {/* Created At */}
          <TableCell>
            <Skeleton className="h-4 w-24" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-4 w-24" />
          </TableCell>
          {/* Actions */}
          <TableCell>
            <Skeleton className="h-8 w-8 rounded" />
          </TableCell>

        </TableRow>
      ))}
    </>
  );
}
